import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/layout.tsx");
